// extracted by mini-css-extract-plugin
export default {"facetMenu":"JA-z","fixed":"KA-z","nonLayerdFacets":"LA-z","productCount":"MA-z","facetBack":"NA-z","arrow":"OA-z","facetClose":"PA-z"};